import { SB } from '@play-co/replicant';
import { getLocaleConfig } from 'src/replicant/creatives/text';
import { tuple } from 'src/replicant/utils/types';
import {
  createFlexMessageTemplate,
  createFlexContainer,
  createOpenGameAction,
} from './utils';

/**
 * Assets for message
 */
export const spawnPetAssets = {
  'background/2024-02-26-onFire':
    'private/chatbot/spawnPet/2024-02-26-onFire.png',
  'background/2024-02-26-openA':
    'private/chatbot/spawnPet/2024-02-26-openA.png',
  'background/2024-02-26-openB':
    'private/chatbot/spawnPet/2024-02-26-openB.png',
  'background/2024-02-26-revealA':
    'private/chatbot/spawnPet/2024-02-26-revealA.png',
  'background/2024-02-26-revealB':
    'private/chatbot/spawnPet/2024-02-26-revealB.png',
  'background/2024-02-26-revealC':
    'private/chatbot/spawnPet/2024-02-26-revealC.png',
};

/**
 * Create spawn pet messages for users to return and start the game
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const spawnPetMessage = createFlexMessageTemplate(
  SB.object({
    creativeAssetID: SB.tuple([
      'background/2024-02-26-onFire',
      'background/2024-02-26-openA',
      'background/2024-02-26-openB',
      'background/2024-02-26-revealA',
      'background/2024-02-26-revealB',
      'background/2024-02-26-revealC',
    ]),
    locale: SB.tuple(['en', 'ja']),
  }),
  (data, payload, api) => {
    const variant = data.creativeAssetID;
    const background = api.getAssetPath(variant);
    let altText = getLocaleConfig(data.locale).spawnPet.open.text;

    switch (variant) {
      case 'background/2024-02-26-onFire':
        altText = getLocaleConfig(data.locale).spawnPet.onFire.text;
        break;
      case 'background/2024-02-26-revealA':
      case 'background/2024-02-26-revealB':
      case 'background/2024-02-26-revealC':
        altText = getLocaleConfig(data.locale).spawnPet.reveal.text;
        break;
    }

    return createFlexContainer(altText, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(altText, payload),
      body: {
        type: 'box',
        layout: 'horizontal',
        contents: [
          {
            type: 'image',
            url: background,
            size: 'full',
            aspectMode: 'cover',
            aspectRatio: '1:1',
            gravity: 'center',
          },
        ],
        paddingAll: '0px',
        justifyContent: 'center',
      },
    });
  },
);
